<ion-header class="ion-no-padding" no-border>
  <nucamptopnav #nucamptopnav [selectedPage]="pagename" [bg]="scrolled"></nucamptopnav>
</ion-header>


<ion-content class="ion-no-padding" [scrollEvents]="true" (ionScroll)="logScrolling($event)">
  <ion-grid *ngIf="hasAccess, else noaccess">
    <ion-row class="stripe-inside component-padding-vertical component-padding-sm" *ngIf="isAdmin">
      <ion-col size="12">
        <ion-item mode="md" class="ion-text-wrap">
          <ion-label>Enter the data to encrypt:</ion-label>
          <ion-input required [(ngModel)]="rawData" name="rawData" type="text"></ion-input>
          <ion-spinner slot="end" *ngIf="fetchingEncrypted"></ion-spinner>
          <ion-button slot="end" [disabled]="!rawData" (click)="encrypt(rawData)">Encrypt</ion-button>
        </ion-item>
        <p *ngIf="encryptedData" class="ion-padding">Result: {{encryptedData}}</p>
      </ion-col>
    </ion-row>
    <ion-row class="stripe-inside component-padding-vertical component-padding-sm">
      <ion-col size="12">
        <ion-item mode="md" class="ion-text-wrap">
          <ion-label>Enter the data to decrypt:</ion-label>
          <ion-input required [(ngModel)]="encryptedData" name="encryptedData" type="text"></ion-input>
          <ion-spinner slot="end" *ngIf="fetchingDecrypted"></ion-spinner>
          <ion-button slot="end" [disabled]="!encryptedData" (click)="decrypt(encryptedData)">Decrypt</ion-button>
        </ion-item>
        <p *ngIf="decryptResult && decryptResult.code !== 200" class="ion-padding">{{decryptResult.error}}</p>
        <p *ngIf="decryptResult && decryptResult.code === 200" class="ion-padding">Decrypted data: {{decryptResult.data}}</p>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #noaccess>
    <ion-grid class="ion-no-padding">
        <ion-row class="stripe-inside component-padding-sm">
          <ion-col size="12">
            <h4>You are not allowed to access this page. Login using an account with the appropriate access.</h4>
          </ion-col>
          <ion-col size="12" class="ion-text-center ion-padding-vertical">
            <login></login>
          </ion-col>
        </ion-row>
    </ion-grid>
  </ng-template>
<footer></footer>
</ion-content>

